import { createRef } from 'react'
import { initAutoAjaxSelect2 } from 'auto_select2/ajax_select2'

export default class MultiAjaxTagsInput extends React.Component {
  constructor (props) {
    super(props)
    this.inputRef = createRef(null)
  }

  UNSAFE_componentWillMount () {
    if (this.props.field === 'skills') this.field = 'skill'
    this.options = {
      multiple: true,
      placeholder: this.props.placeholder || '',
      additional_ajax_data: {
        selector: '.dependent-input'
      }
    }
  }

  componentDidMount () {
    $(this.inputRef.current).ready(() => { // jQuery must be ready for call initAutoAjaxSelect2()
      initAutoAjaxSelect2()
      this.select2 = $(this.inputRef.current).data('select2')
      this.select2.container.attr('data-label', this.props.value ? this.props.placeholder || '' : '')
      $(this.inputRef.current).on({
        'select2-focus': (e) => {
          this.select2.container.attr('data-label', this.props.placeholder || '')
            .toggleClass('show-labelholder', true)
        },
        'select2-blur': (e) => {
          const value = $(this.inputRef.current).val()
          this.select2.container.attr('data-label', value ? this.props.placeholder || '' : '')
            .toggleClass('show-labelholder', !!value)
        },
        change: (e) => {
          // Callback
          if (typeof this.props.onChange === 'function') this.props.onChange($(this.inputRef.current).val(), e)
        }
      })
    })
  }

  componentDidUpdate () {
    if (this.props.value !== this.inputRef.current.value) $(this.inputRef.current).val((this.props.value)).trigger('change')
  }

  render () {
    const { name, value, field, select2url } = this.props

    return (
      <input
        type='text' name={name} defaultValue={value}
        className={`auto-ajax-select2 labelholder ${value && 'show-labelholder'}`}
        data-s2-options={JSON.stringify(this.options)}
        data-s2-href={`/select2_autocompletes/${select2url || this.field || field}`}
        data-s2-limit='25' tabIndex='-1'
        ref={this.inputRef}
        id={field}
      />
    )
  }
}

MultiAjaxTagsInput.propTypes = {
  field: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  select2url: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
}
